require('./bootstrap');

(function ($) {
  "use strict";

  /* FOR DESKTOP ONLY */
  if (window.matchMedia("(min-width: 992px)").matches) {

    /* LIEN PREMIER NIVEAU AVEC DROPDOWN CLICKABLE */
    $('.dropdown-toggle').removeAttr('data-toggle');

    /* BS4 TOOLTIP JS */
    $('[data-toggle="tooltip"]').tooltip();


    /* GO TOP */
    $(window).on('scroll', function () {
      if ($(window).scrollTop() < 150) {
        $('#goTop').fadeOut();
      } else {
        $('#goTop').fadeIn();
      }
    });

  };

  /* JS EFFET NAVBAR AU TOP (version STUCK) */
  (new IntersectionObserver(function (e) {
    if (e[0].intersectionRatio > 0) {
      document.documentElement.removeAttribute('class');
    } else {
      document.documentElement.setAttribute('class', 'stuck');
    };
    })).observe(document.querySelector('.trigger'));


  /* ADD LINK ARROUND MAIN CONTENT IMAGES */
  $('#main img').each(function () {
    var currentImg = $(this);
    currentImg.wrap("<a data-fancybox='gallery' href='" + currentImg.attr("src") + "'></a>");
  });

  /* ADD RESPONSIVE DIV ARROUND EMBED IFRAME (YOUTUBE VIDEO) */
  $('#main iframe').each(function () {
    var currentVideo = $(this);
    currentVideo.wrap("<div class='embed-responsive embed-responsive-16by9'></div>");
  });

  /* FANCYBOX OPTIONS */
  $('[data-fancybox]').fancybox({
    protect: true,
    transitionEffect: "slide",
    wheel: "auto",
    caption: function( instance, item ) {
      return $(this).find('img').attr('alt');
    },
    buttons: [
      "zoom",
      "close"
    ],
  });

})(jQuery);
